import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import attendeeReducer from './attendeeSlice';
import webinarReducer from './webinarSlice';
import dashboardReducer from './dashboardSlice';
import updateWebinarReducer from './updateWebinarSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    attendees: attendeeReducer,
    dashboard : dashboardReducer,
    webinars: webinarReducer,
    updateWebinar: updateWebinarReducer,
  },
});
